import { FormTab, FormTabProps, required } from 'react-admin';
import { CraftPageSection } from 'src/components/CraftPageSection';
import TextInput from 'src/inputs/TextInput';

const TITLE = 'General';

const PassportGeneral = (props: Omit<FormTabProps, 'label'>) => (
  <FormTab label={TITLE} {...props}>
    <CraftPageSection title={TITLE}>
      <TextInput source="name" label="Name" validate={required()} fullWidth />
      <TextInput source="description" label="Description" multiline rows={3} fullWidth />
    </CraftPageSection>
  </FormTab>
);

export default PassportGeneral;
